import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerBasedProfile } from 'app/main/apps/common/AuraFunctions';
import Navigation from '../../shared-components/Navigation';


const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
}));

function NavbarLayout2(props) {
  const currentUser = useSelector(({ user }) => user);
  const { role } = currentUser

  return (
    <Root className={clsx(`w-full  min-h-64  shadow-md ${role !== 'customer' ? 'h-64 max-h-64' : ''}`, props.className)}>
      <div className="flex flex-auto justify-between items-center w-full h-full container p-0 lg:px-24 z-20">
        <div className="flex shrink-0 items-center px-8">
          <img className="w-160 my-6" src={getCustomerBasedProfile.navbarLogo} alt="logo" />
        </div>

        <FuseScrollbars className="flex h-full items-center">
          <Navigation className="w-full" layout="horizontal" />
        </FuseScrollbars>
      </div>
    </Root>
  );
}

export default memo(NavbarLayout2);
